import * as React from 'react';

import Typography from '@mui/material/Typography';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import { CardActionArea } from '@mui/material';
import { Divider } from "@mui/material";

import Avatar from '@mui/material/Avatar';
import { red } from '@mui/material/colors';

import LastAssessmentAt from '../LastAssessmentAt';
import AnimalChangeSummary from '../AnimalChangeSummary';


export default function AnimalCard({animal,lastAssessment = undefined, changes = [], onActionAreaClick,...props}) {

    // note you can play with the container maxwidth to spread out the window content appears in
    return (
        <Card>
            <CardActionArea onClick={onActionAreaClick}>
                <CardHeader 
                    title={animal.name}  
                    titleTypographyProps={{variant: "h5"}} 
                    subheader={[animal.studbook_number, animal.location].filter(Boolean).join(' · ')}
                    avatar={
                        <Avatar sx={{ bgcolor: red[500] }}>{animal.name.charAt(0).toUpperCase()}</Avatar>
                    }
                />
                <Divider />
                <CardContent>
                    <Typography variant="body1" sx={{marginY: 1}}>
                        Species: {animal.species || "Unknown"}
                    </Typography>

                    {lastAssessment !== undefined && 

                    <Typography variant="body1" sx={{marginY: 1}}>
                        Last/Active Assessment: <LastAssessmentAt assessment={lastAssessment} />
                    </Typography>
                    }

                    <AnimalChangeSummary animal={animal} changes={changes} containerProps={{sx: {marginY: 1}}}/>
                </CardContent>
            </CardActionArea>
        </Card> 
    );
}
